/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetMiniPdpProductQueryVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
}>;

export type GetMiniPdpProductQuery = {
  __typename?: "Query";
  shopProductBySkuId?: {
    __typename?: "ShopProduct";
    id: string;
    name: string;
    description?: string | null;
    brand: { __typename?: "Brand"; name: string };
    variantBySkuId?: {
      __typename?: "ShopProductVariant";
      id: string;
      sku: string;
      priceType?: Types.Price | null;
      media: Array<{
        __typename?: "ShopMedia";
        altText: string;
        contentGroup: string;
        originalSrc: string;
        position: number;
      }>;
      color: { __typename?: "Color"; name: string };
      size: { __typename?: "Size"; name: string };
      inseam?: { __typename?: "Inseam"; name: string } | null;
      detailGroups: Array<{
        __typename?: "ProductDetailGroup";
        key: string;
        details: Array<{ __typename?: "ProductDetail"; label: string; value: string }>;
      }>;
      price: { __typename?: "Money"; currency: Types.Currency; value: number };
      priceMarkdown?: {
        __typename?: "PriceMarkdown";
        discountLabel: string;
        percentage: number;
        amount: { __typename?: "Money"; currency: Types.Currency; value: number };
        fullPrice: { __typename?: "Money"; currency: Types.Currency; value: number };
      } | null;
      priceStickerLabel?: {
        __typename?: "ModeStickerLabel";
        label: string;
        theme: Types.ModeStickerLabelTheme;
      } | null;
      installmentPayments: { __typename?: "InstallmentPayments"; label: string };
      buyNowPayLaterHelpContent?: {
        __typename?: "BuyNowPayLaterHelpContent";
        helpIcon: Types.ModeIcon;
        paymentOptionIcons: Array<Types.ModeIcon>;
        paymentOptionIconsForPriceLabel: Array<Types.ModeIcon>;
        helpModuleBodyCopy: {
          __typename?: "BuyNowPayLaterHelpContentBodyCopy";
          formatted: string;
          plain: string;
          links: Array<{
            __typename?: "BuyNowPayLaterHelpContentLink";
            destinationPath: string;
            placeholder: string;
            text: string;
          }>;
        };
        helpModuleHeaderCopy: { __typename?: "RichText"; formatted: string; plain: string };
      } | null;
    } | null;
  } | null;
};

export const GetMiniPdpProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMiniPdpProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shopProductBySkuId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "skuId" },
                value: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "brand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "variantBySkuId" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "skuId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "sku" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "contentType" },
                                  value: { kind: "EnumValue", value: "IMAGE" },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "altText" } },
                            { kind: "Field", name: { kind: "Name", value: "contentGroup" } },
                            { kind: "Field", name: { kind: "Name", value: "originalSrc" } },
                            { kind: "Field", name: { kind: "Name", value: "position" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "color" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "size" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inseam" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "detailGroups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "price" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceMarkdown" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "amount" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "currency" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "discountLabel" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullPrice" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "currency" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "percentage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceStickerLabel" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "theme" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "priceType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "installmentPayments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "label" } }],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "buyNowPayLaterHelpContent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "helpIcon" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "helpModuleBodyCopy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "plain" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "links" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "destinationPath" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "placeholder" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "text" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "helpModuleHeaderCopy" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "formatted" } },
                                  { kind: "Field", name: { kind: "Name", value: "plain" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "paymentOptionIcons" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentOptionIconsForPriceLabel" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetMiniPdpProductQuery__
 *
 * To run a query within a React component, call `useGetMiniPdpProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiniPdpProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiniPdpProductQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useGetMiniPdpProductQuery(
  baseOptions: Apollo.QueryHookOptions<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables> &
    ({ variables: GetMiniPdpProductQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>(
    GetMiniPdpProductDocument,
    options,
  );
}
export function useGetMiniPdpProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMiniPdpProductQuery,
    GetMiniPdpProductQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>(
    GetMiniPdpProductDocument,
    options,
  );
}
// @ts-ignore
export function useGetMiniPdpProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMiniPdpProductQuery,
    GetMiniPdpProductQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>;
export function useGetMiniPdpProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetMiniPdpProductQuery | undefined,
  GetMiniPdpProductQueryVariables
>;
export function useGetMiniPdpProductSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMiniPdpProductQuery, GetMiniPdpProductQueryVariables>(
    GetMiniPdpProductDocument,
    options,
  );
}
export type GetMiniPdpProductQueryHookResult = ReturnType<typeof useGetMiniPdpProductQuery>;
export type GetMiniPdpProductLazyQueryHookResult = ReturnType<typeof useGetMiniPdpProductLazyQuery>;
export type GetMiniPdpProductSuspenseQueryHookResult = ReturnType<
  typeof useGetMiniPdpProductSuspenseQuery
>;
export type GetMiniPdpProductQueryResult = Apollo.QueryResult<
  GetMiniPdpProductQuery,
  GetMiniPdpProductQueryVariables
>;
